<!-- Просмотр состава ПЛАНа, результата и отличий от значений калькулятора. -->
<template>
  <div class="plan-breakdown">
    <div class="plan-breakdown__version">
      {{ presetName }} · v{{ version }}
    </div>

    <div v-for="item in breakdown" :key="item.code" class="plan-breakdown__row">
      <span class="plan-breakdown__name">
        <span>{{ item.name }}</span>
        <PlanCalculationBreakdownOrigin
          :origin="item.origin"
          :token="tooltipToken(item)"
          :token-labels="tokenLabels"
        />
      </span>
      <span>{{ formatNumber(item.value) }}</span>
    </div>

    <div class="plan-breakdown__total" :class="`plan-breakdown__total--${resultTone}`">
      <span>{{ resultName }}</span>
      <span>{{ formatResult(result, resultUnit) }}</span>
    </div>

    <div v-if="changedRows.length" class="plan-breakdown__pending">
      Это текущая версия v{{ version }}. Изменённые исходные данные
      (<span>{{ changedNames }}</span>) войдут в расчёт после
      «Пересчитать → v{{ Number(version) + 1 }}».
    </div>
  </div>
</template>

<script>
import PlanCalculationBreakdownOrigin from "@/components/Order/PlanCalculation/BreakdownOrigin.vue";
import { buildFormulaTokenLabels } from "@/utils/formulaSuggestionUtils";
import { formatBigNumber } from "@/utils/numberUtils";
import { buildBreakdownTooltipToken } from "@/utils/orderCalculation/breakdownUtils";

const UNIT_SUFFIXES = {
  rub: " ₽",
  percent: " %",
  km: " км",
  hours: " ч",
  days: " дн.",
  liters: " л",
  number: "",
};

export default {
  name: "OrderPlanCalculationBreakdown",

  components: { PlanCalculationBreakdownOrigin },

  props: {
    breakdown: { type: Array, default: () => [] },
    result: { type: [String, Number], default: null },
    resultName: { type: String, default: "Результат" },
    resultUnit: { type: String, default: "rub" },
    resultTone: {
      type: String,
      default: "neutral",
      validator: (value) => ["negative", "neutral", "positive"].includes(value),
    },
    presetName: { type: String, default: "Калькулятор" },
    version: { type: [String, Number], required: true },
    changedRows: { type: Array, default: () => [] },
    presetParams: { type: Array, default: () => [] },
  },

  computed: {
    changedNames() {
      return this.changedRows.map((row) => row.name).join(", ");
    },
    tokenLabels() {
      return buildFormulaTokenLabels(this.presetParams);
    },
  },

  methods: {
    formatNumber(value) {
      return formatBigNumber(value);
    },
    formatResult(value, unit) {
      return `${formatBigNumber(value)}${UNIT_SUFFIXES[unit] || ""}`;
    },
    tooltipToken(item) {
      return buildBreakdownTooltipToken(item, this.tokenLabels);
    },
  },
};
</script>

<style scoped>
.plan-breakdown__row,
.plan-breakdown__total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 14px;
  font-variant-numeric: tabular-nums;
}

.plan-breakdown__version {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 0 14px;
  color: #5b6070;
  font-size: 12px;
}

.plan-breakdown__row {
  min-height: 34px;
  border-top: 1px solid #f3f5f9;
  font-size: 14px;
}

.plan-breakdown__name {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.plan-breakdown__row:first-child {
  border-top: 0;
}

.plan-breakdown__total {
  height: 38px;
  background: #e8f7f1;
  color: #15803d;
  font-size: 14px;
  font-weight: 700;
}

.plan-breakdown__total--negative {
  background: #fef2f2;
  color: #b42318;
}

.plan-breakdown__pending {
  padding: 10px 14px;
  border-top: 1px solid #e0e7ff;
  background: #f5f7ff;
  color: #4b5068;
  font-size: 13px;
  line-height: 1.4;
}

.plan-breakdown__pending span {
  color: #854d0e;
}
</style>
